import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect, useCallback } from 'react';
import { usePostRewardOfferHistoryDetailsMutation, usePostRewardOfferHistorySendEmailMutation } from '../../../state/query/rewardCenter';
import { getText, TEXT_KEY } from '../../../utils/localization';
import { EVENT_TYPES } from '../../../lib/analytics/constants';
import ERROR_CODE from '../../../utils/errorCodes';
import Logger from '../../../lib/analytics/logger';
import audio from '../../../utils/audio';

var useRewardCenterHistoryDetails = function useRewardCenterHistoryDetails(activeHistoryItemId) {
  var _usePostRewardOfferHi = usePostRewardOfferHistoryDetailsMutation(),
      _usePostRewardOfferHi2 = _slicedToArray(_usePostRewardOfferHi, 2),
      postRewardOfferHistoryDetailsMutation = _usePostRewardOfferHi2[0],
      isLoading = _usePostRewardOfferHi2[1].isLoading;

  var _usePostRewardOfferHi3 = usePostRewardOfferHistorySendEmailMutation(),
      _usePostRewardOfferHi4 = _slicedToArray(_usePostRewardOfferHi3, 1),
      postRewardOfferHistorySendEmail = _usePostRewardOfferHi4[0];

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      offerHistoryDetails = _useState2[0],
      setOfferHistoryDetails = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      emailSentMessage = _useState4[0],
      setEmailSentMessage = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      voucherCode = _useState6[0],
      setVoucherCode = _useState6[1];

  useEffect(function () {
    var getPlayerOfferDetails = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _details$barcodeImage, details, newVoucherCode;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                audio.onClick();
                _context.prev = 1;
                _context.next = 4;
                return postRewardOfferHistoryDetailsMutation({
                  activeHistoryItemId: activeHistoryItemId
                });

              case 4:
                _context.next = 6;
                return _context.sent.data;

              case 6:
                details = _context.sent;
                setOfferHistoryDetails(details);
                newVoucherCode = (_details$barcodeImage = details.barcodeImageURL) === null || _details$barcodeImage === void 0 ? void 0 : _details$barcodeImage.slice(details.barcodeImageURL.search('=') + 1);
                setVoucherCode(newVoucherCode);
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](1);
                Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                  error: JSON.stringify(_context.t0, Object.getOwnPropertyNames(_context.t0)),
                  code: ERROR_CODE.GET_OFFER_HISTORY_DETAILS_REQUEST_ERROR
                });

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 12]]);
      }));

      return function getPlayerOfferDetails() {
        return _ref.apply(this, arguments);
      };
    }();

    getPlayerOfferDetails();
  }, [activeHistoryItemId, postRewardOfferHistoryDetailsMutation]);
  var onSendEmail = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            audio.onClick();
            _context2.prev = 1;
            _context2.next = 4;
            return postRewardOfferHistorySendEmail({
              activeHistoryItemId: activeHistoryItemId
            });

          case 4:
            setEmailSentMessage(getText(TEXT_KEY.EMAIL_SENT_MESSAGE));
            _context2.next = 10;
            break;

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](1);
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              error: JSON.stringify(_context2.t0, Object.getOwnPropertyNames(_context2.t0)),
              code: ERROR_CODE.SEND_OFFER_EMAIL_REQUEST_ERROR
            });

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 7]]);
  })), [activeHistoryItemId, postRewardOfferHistorySendEmail]);
  return {
    offerHistoryDetails: offerHistoryDetails,
    emailSentMessage: emailSentMessage,
    onSendEmail: onSendEmail,
    voucherCode: voucherCode,
    isLoading: isLoading
  };
};

export default useRewardCenterHistoryDetails;